
  (function () {
    const mfKey = '__module_federation__containers';
    window[mfKey] = window[mfKey] || {};
    window[mfKey]['bd59b79d-a12b-406d-914a-b85843e83362'] = window[mfKey]['bd59b79d-a12b-406d-914a-b85843e83362'] || {
      get: async (cmpId) => {
        const importFn = window[mfKey]['bd59b79d-a12b-406d-914a-b85843e83362'][cmpId];
        const Component = await importFn();
        return () => Component;
      },
      init: async () => {
        
      },
    };

    window[mfKey]['bd59b79d-a12b-406d-914a-b85843e83362']['983e2133-1af8-43fe-9721-c70927e1f812'] = () => import('/src/dashboard/pages/page.tsx');
  })();